import { Component, OnInit } from '@angular/core';
import { RequestLogging } from '../../models/request-logging';
import { DomSanitizer } from '@angular/platform-browser';
import { RequestLoggingService } from '../../services/request-logging.service';
import { NbDialogRef } from '@nebular/theme';
import { Router } from '@angular/router';

@Component({
  selector: 'request-logging-details',
  templateUrl: './request-logging-details.component.html',
  styleUrls: ['./request-logging-details.component.scss']
})
export class RequestLoggingDetailsComponent implements OnInit {
 model = {} as RequestLogging;
  constructor(private route: Router,
      private diag: NbDialogRef<RequestLoggingDetailsComponent>,
      public sanitizer: DomSanitizer,
      private service: RequestLoggingService) { }

 ngOnInit() {
       this.route.events.subscribe(()=>{
       this.diag.close('false');
      });
   }

   getLabelData(text) {
     return this.sanitizer.bypassSecurityTrustHtml(text);
   }
 
   close() {
     this.diag.close();
   }

   formatJson(jsonString: string): string {
     try {
       if (!jsonString) return 'لا يوجد';
       const obj = JSON.parse(jsonString);
       return JSON.stringify(obj, null, 2);
     } catch (e) {
       return jsonString || 'لا يوجد';
     }
   }

}

